import React, {useEffect} from 'react';
import {CardFooter} from "@material-tailwind/react";

const PagandoPaymentButton = (amount, orderId) => {
    useEffect(() => {
        if (PagandoCheckout) {
            PagandoCheckout.setCredentials({
                user: 'd53b6d1d758b1e8ab977901b8a978f67c22b368a',
                publicKey: 'Test ce2b5e83474c8b1a7d8582b08e5a7e58940bb1d8',
            });

            // TODO - Remove
            console.log('Amount:', amount);
            console.log('OrderID:', orderId);

            PagandoCheckout.button('pagando-button-container', {
                createOrder: function () {
                    return {
                        amount: amount,
                        orderId: orderId,
                    };
                },
            });
        }
    }, [amount, orderId]);

    return (
        <CardFooter className='flex justify-start p-0 mt-2 mb-2'>
            <div id='pagando-button-container' className='mx-auto md:ml-0 border-solid border-2 border-green-500 text-white rounded-md text-lg hover:scale-110'></div>
        </CardFooter>
    )
};

export default PagandoPaymentButton;
